<template>
    <mm-select :options="group" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			group:[],
		}
	},
	props:['value'],
	async mounted(){
		if(!this.$cache['group']){
			const body = await this.$post('/user/groupList',{attributes:['group_id','group_name']});
			this.$cache['group'] = body.rows.map(v=>{return {value:v['group_id'],label:v['group_name']}});
		}
		this.group = this.$cache['group'];
	}
}
</script>
